module.exports = __webpack_public_path__ + "img/es-ct.4cf48425.svg";